module.exports = __webpack_public_path__ + "img/03.ae4a5f61.png";